import React, {Component} from 'react';
import converter from 'number-to-words';
import NumberFormat from 'react-number-format';
import $ from 'jquery';
import PaperSignatories from '../../../../view/PaperSignatories';
import PaperSignatoriesAcknowledgement from '../../../../view/PaperSignatoriesAcknowledgement';
import {Noun, SubjectVerb} from '../../../../model/Helper';
import PaperParty from '../../../../view/PaperParty';
import {blank_line} from '../../../../model/Const';

class Preview extends Component {

    constructor(props) {
        super(props);
        this.state = {
            focus: ".paper-title"
        }
    }

    isVisible(el) {
		var elementTop = $(el).offset().top;
		var elementBottom = elementTop + $(el).outerHeight();
	
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();
	
		return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    componentDidMount() {

		$(window).scroll(()=>{

			// This setup will be enabled only with at least md window width
			if($(window).width()>767){
				// Header setup
				// Make preview stay at the top and fixed display when header is not visible
				if(this.isVisible(".header")){
					$(".right-preview .preview").css({
						"position": "relative",
						"top": "auto",
						"padding-right": "0"
					});
				} else {
					$(".right-preview .preview").css({
						"position": "fixed",
						"top": "1rem",
						"padding-right": "15px"
					});
				}

			}
        });
        
    }
    
    componentWillReceiveProps(newProps) {
		let ff = newProps.formFocus?newProps.formFocus:'paper-title';

        this.setState({
            focus: '.'+ff
        }, ()=>{
            //console.log(this.state.focus)
            let screenPos = $(window).height()/3;
            let el = $(this.state.focus).length?$(this.state.focus):$(".paper-title");
            let scrollVal = el.get(0).offsetTop-screenPos || 0;
            
            $(".paper").animate({
                scrollTop: scrollVal
            }, 100);
            
        });
    }

    render() {

        let p = this.props.details.property;
        let s = this.props.details.seller;
        let b = this.props.details.buyer;
        //let pa = this.props.details.payment;

        let nounSeller = Noun(s, "seller");
        let nounBuyer = Noun(b, "buyer");

        let blankLine = blank_line;

        // Natural person variables
        let sellerName = [], 
            sellerSpouseName = [],
            sellerNationality = [],
            sellerAddress = [],
            sellerRepresentativeName = [],
            sellerRepresentativeNationality = [],
            sellerRepresentativeAddress = [],
            sellerTin = [];
        // Corporation variables
        let sellerCorporationName = [],
            sellerCorporationPrincipalPlaceOfBusiness = [],
            sellerCorporationRepresentativeName = [],
            //sellerCorporationRepresentativePosition = [],
            sellerCorporationTin = [];
        this.props.details.seller.forEach((seller, i)=>{
            sellerName[i] = (seller.sellerFname || seller.sellerMname || seller.sellerLname) ? 
                                    (seller.sellerFname+(seller.sellerMname?` ${seller.sellerMname}`:"")+(seller.sellerLname?` ${seller.sellerLname}`:"")+(seller.sellerSuffix?` ${seller.sellerSuffix}`:"")): 
                                    blankLine;
            sellerSpouseName[i] = (seller.sellerSpouseFname || seller.sellerSpouseMname || seller.sellerSpouseLname) ? 
            (seller.sellerSpouseFname+(seller.sellerSpouseMname?` ${seller.sellerSpouseMname}`:"")+(seller.sellerSpouseLname?` ${seller.sellerSpouseLname}`:"")+(seller.sellerSpouseSuffix?` ${seller.sellerSpouseSuffix}`:"")): 
            blankLine;
            sellerNationality[i] = seller.sellerNationality ? seller.sellerNationality : blankLine;
            sellerAddress[i] = seller.sellerAddress ? seller.sellerAddress :  blankLine;
            
            sellerRepresentativeName[i] = (seller.sellerRepresentativeFname || seller.sellerRepresentativeMname || seller.sellerRepresentativeLname) ? 
                                    (seller.sellerRepresentativeFname+(seller.sellerRepresentativeMname?` ${seller.sellerRepresentativeMname}`:"")+(seller.sellerRepresentativeLname?` ${seller.sellerRepresentativeLname}`:"")+(seller.sellerRepresentativeSuffix?` ${seller.sellerRepresentativeSuffix}`:"")): 
                                    blankLine;
            sellerRepresentativeNationality[i] = seller.sellerRepresentativeNationality ? seller.sellerRepresentativeNationality : blankLine;
            sellerRepresentativeAddress[i] = seller.sellerRepresentativeAddress ? seller.sellerRepresentativeAddress :  blankLine;
            sellerTin[i] = seller.sellerTin ? seller.sellerTin : "";

            sellerCorporationName[i] = seller.sellerCorporationName ? seller.sellerCorporationName : blankLine;
            sellerCorporationPrincipalPlaceOfBusiness[i] = seller.sellerCorporationPrincipalPlaceOfBusiness ? seller.sellerCorporationPrincipalPlaceOfBusiness : blankLine;
            
            sellerCorporationRepresentativeName[i] = (seller.sellerCorporationRepresentativeFname || seller.sellerCorporationRepresentativeMname || seller.sellerCorporationRepresentativeLname) ? 
                                    (seller.sellerCorporationRepresentativeFname+(seller.sellerCorporationRepresentativeMname?` ${seller.sellerCorporationRepresentativeMname}`:"")+(seller.sellerCorporationRepresentativeLname?` ${seller.sellerCorporationRepresentativeLname}`:"")+(seller.sellerCorporationRepresentativeSuffix?` ${seller.sellerCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            sellerCorporationTin[i] = seller.sellerCorporationTin ? seller.sellerCorporationTin : "";
        });

        // Natural person variables
        let buyerName = [], 
            buyerSpouseName = [],
            buyerNationality = [],
            buyerAddress = [],
            buyerRepresentativeName = [],
            buyerRepresentativeNationality = [],
            buyerRepresentativeAddress = [],
            buyerTin = [];
        // Corporation variables
        let buyerCorporationName = [],
            buyerCorporationPrincipalPlaceOfBusiness = [],
            buyerCorporationRepresentativeName = []
        this.props.details.buyer.forEach((buyer, i)=>{
            buyerName[i] = (buyer.buyerFname || buyer.buyerMname || buyer.buyerLname) ? 
                                    (buyer.buyerFname+(buyer.buyerMname?` ${buyer.buyerMname}`:"")+(buyer.buyerLname?` ${buyer.buyerLname}`:"")+(buyer.buyerSuffix?` ${buyer.buyerSuffix}`:"")): 
                                    blankLine;
            buyerSpouseName[i] = (buyer.buyerSpouseFname || buyer.buyerSpouseMname || buyer.buyerSpouseLname) ? 
            (buyer.buyerSpouseFname+(buyer.buyerSpouseMname?` ${buyer.buyerSpouseMname}`:"")+(buyer.buyerSpouseLname?` ${buyer.buyerSpouseLname}`:"")+(buyer.buyerSpouseSuffix?` ${buyer.buyerSpouseSuffix}`:"")): 
            blankLine;
            buyerNationality[i] = buyer.buyerNationality ? buyer.buyerNationality : blankLine;
            buyerAddress[i] = buyer.buyerAddress ? buyer.buyerAddress :  blankLine;
            
            buyerRepresentativeName[i] = (buyer.buyerRepresentativeFname || buyer.buyerRepresentativeMname || buyer.buyerRepresentativeLname) ? 
                                    (buyer.buyerRepresentativeFname+(buyer.buyerRepresentativeMname?` ${buyer.buyerRepresentativeMname}`:"")+(buyer.buyerRepresentativeLname?` ${buyer.buyerRepresentativeLname}`:"")+(buyer.buyerRepresentativeSuffix?` ${buyer.buyerRepresentativeSuffix}`:"")): 
                                    blankLine;
            buyerRepresentativeNationality[i] = buyer.buyerRepresentativeNationality ? buyer.buyerRepresentativeNationality : blankLine;
            buyerRepresentativeAddress[i] = buyer.buyerRepresentativeAddress ? buyer.buyerRepresentativeAddress :  blankLine;

            buyerCorporationName[i] = buyer.buyerCorporationName ? buyer.buyerCorporationName : blankLine;
            buyerCorporationPrincipalPlaceOfBusiness[i] = buyer.buyerCorporationPrincipalPlaceOfBusiness ? buyer.buyerCorporationPrincipalPlaceOfBusiness : blankLine;
            
            buyerCorporationRepresentativeName[i] = (buyer.buyerCorporationRepresentativeFname || buyer.buyerCorporationRepresentativeMname || buyer.buyerCorporationRepresentativeLname) ? 
                                    (buyer.buyerCorporationRepresentativeFname+(buyer.buyerCorporationRepresentativeMname?` ${buyer.buyerCorporationRepresentativeMname}`:"")+(buyer.buyerCorporationRepresentativeLname?` ${buyer.buyerCorporationRepresentativeLname}`:"")+(buyer.buyerCorporationRepresentativeSuffix?` ${buyer.buyerCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            buyerTin[i] = buyer.buyerTin ? buyer.buyerTin : "";  
        });

        let priceNumber = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ?
                                <NumberFormat value={parseFloat(p.price)} displayType="text" thousandSeparator={true} /> :
                                blankLine;		
        let priceText = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ?
                            converter.toWords(p.price) : 
                            blankLine;
        
        return (
            <div className="preview">
                <div className="default-preview-fade top"></div>
                <div className="top-preview">
                    <div className="text-center">
                        <p>Preview</p>
                    </div>
                    
                    <div className="paper">
                    <div className="paper-inner">
                        
                        <div className="paper-title text-center">
							Deed of Sale of Motor Vehicle
						</div>

                        <div className="text-uppercase">
                            <p className="no-indent">
                                KNOW ALL MEN BY THESE PRESENTS:
                            </p>
                        </div>

                        <div>
                            <p>
                            This Deed of Sale of Motor Vehicle (hereinafter "Deed") is made and entered into by and between:
                            </p>
                        </div>

                        <PaperParty party={s} type="seller" />

                        <div className="my-3 text-center paper-narrow">
                            <div className="my-3">- and -</div>
                        </div>

                        <PaperParty party={b} type="buyer" />

                        <div className="my-3 text-center paper-narrow">
                            <div className="my-3"><strong>WITNESSETH</strong>: That-</div>
                        </div>

                        <div>
                            <p>
                                WHEREAS, for and in consideration of the sum of <span className="dynamic-data text-uppercase property_price">{priceText}</span> PESOS (P<span className="dynamic-data">{priceNumber}</span>) Philippine Currency, receipt of which is hereby acknowledged, the <span className="text-uppercase">{nounSeller}</span> hereby SELL, TRANSFER and CONVEY unto the <span className="text-uppercase">{nounBuyer}</span> its heirs and assigns, on an “as is where is” basis, free and clear of all liens, encumbrances, or claims whatsoever, a certain motor vehicle more particularly described as follows:   
                            </p>
                            <table className="table table-bordered table-even table-sm property_make property_mvFileNo property_series property_plateConductionNo property_bodyType property_engineNo property_yearModel property_chassisNo">
                                <tbody>
                                    <tr>
                                        <td>Make:<br /><span className="dynamic-data font-weight-bold text-uppercase">{p.make}</span></td>
                                        <td>MV File No.<br /><span className="dynamic-data font-weight-bold text-uppercase">{p.mvFileNo}</span></td>
                                    </tr>
                                    <tr>
                                        <td>Series:<br /><span className="dynamic-data font-weight-bold text-uppercase">{p.series}</span></td>
                                        <td>Plate No. / Conduction Sticker No.<br /><span className="dynamic-data font-weight-bold text-uppercase">{p.plateConductionNo}</span></td>
                                    </tr>
                                    <tr>
                                        <td>Body Type:<br /><span className="dynamic-data font-weight-bold text-uppercase">{p.bodyType}</span></td>
                                        <td>Engine No.<br /><span className="dynamic-data font-weight-bold text-uppercase">{p.engineNo}</span></td>
                                    </tr>
                                    <tr>
                                        <td>Year Model:<br /><span className="dynamic-data font-weight-bold text-uppercase">{p.yearModel}</span></td>
                                        <td>Chassis No.<br /><span className="dynamic-data font-weight-bold text-uppercase">{p.chassisNo}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                                
                        <div>
                            <p>
                                WHEREAS, the <span className="text-uppercase">{nounSeller}</span> {SubjectVerb(nounSeller, "is")} the absolute and registered owner of the subject motor vehicle covered by Certificate of Registration No. <span className="dynamic-data property_certificateOfRegistrationNo text-uppercase">{p.certificateOfRegistrationNo}</span> issued by the Land Transportation Office.
                            </p>
                        </div>
                        
                        <br />
                        <br />

                        <div>
                            <p>
                                IN WITNESS WHEREOF, the parties have hereunto set their hands this _______________ in _______________. 
                            </p>
                        </div>

                        <br />
                        <br />

                        <PaperSignatories party1={s} party2={b} />
                        
                        <br /><br />
                        <hr />
                        <br /><br />
                        
                        {
                        /**
                         * Acknowledgement section
                         */
                        }
                        <div className="paper-top-left d-inline-block">
							<div>REPUBLIC OF THE PHILIPPINES )</div>
							<div>)S.S.</div>
						</div>

                        <div className="paper-title text-center">
							Acknowledgement
						</div>

                        <div>
                            <p>
                                BEFORE ME, a Notary Public for and in the above jurisdiction, this _______________, personally appeared the following:
                            </p>
                        </div>

                        <PaperSignatoriesAcknowledgement party1={s} party2={b} />

                        <div>
                            <p>
                                Known to me and to me known to be the same persons who executed the foregoing Deed of Sale of Motor Vehicle consisting of <span className="dynamic-data"><small className="text-muted font-italic">[to be filled up by the system]</small></span> pages, including this page where the acknowledgement is written, signed by the parties on each and every page hereof, and acknowledged to me that the same is their free and voluntary act and deed.
                            </p>
                            <p>
                                WITNESS MY HAND AND SEAL in the place and on the date first above written.
                            </p>
                        </div>

                        <br />
                        <br />
                        <div className="docno">
							Doc No. ________; <br />
							Page No. _______; <br />
							Book No. _______; <br />
							Series of 20 ___. <br />
						</div>

                    </div>
                    </div> {/** End of paper */}
                            
                </div>

                <div className="default-preview-fade"></div>
            </div>
        );
    }

}

export default Preview;



// WEBPACK FOOTER //
// ./src/pages/contracts/business/deed-of-sale-of-motor-vehicle/Preview.js